import script from "./invoice-detail-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./invoice-detail-dialog.vue?vue&type=script&lang=tsx&setup=true"

import "./invoice-detail-dialog.vue?vue&type=style&index=0&id=805d8774&lang=scss"

const __exports__ = script;

export default __exports__